var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0833 3.92498C16.0062 3.84772 15.9147 3.78644 15.8139 3.74462C15.713 3.7028 15.605 3.68127 15.4958 3.68127C15.3867 3.68127 15.2786 3.7028 15.1778 3.74462C15.077 3.78644 14.9854 3.84772 14.9083 3.92498L5.83333 12.9916V8.33331C5.83333 7.87498 5.45833 7.49998 5 7.49998C4.54166 7.49998 4.16666 7.87498 4.16666 8.33331V15C4.16666 15.4583 4.54166 15.8333 5 15.8333H11.6667C12.125 15.8333 12.5 15.4583 12.5 15C12.5 14.5416 12.125 14.1666 11.6667 14.1666H7.00833L16.0833 5.09164C16.4 4.77498 16.4 4.24164 16.0833 3.92498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceive);
export default __webpack_public_path__ + "static/media/receive.ee8a52d7280e8af9cd2ed6ff4136c9ce.svg";
export { ForwardRef as ReactComponent };